import { validatorFactory } from '../containers/App/validators';
import validations from '../containers/Tryandbuy/validations';

export const normalizeEmail = (email) =>
  email ? email.toLowerCase().replace(/\s/g, '') : '';

export const isInvalidEmail = (email) =>
  validatorFactory(validations).email(email, {});
